<template>
  <div class="certificate">
    <title-bg :title="title"></title-bg>
    <img src="../../assets/image/certificate-icon.png" alt="" class="certificate-icon">
  </div>
</template>
<script>
import TitleBg from '../../components/TitileBg'
export default {
  components: {
    TitleBg
  },
  data () {
    return {
      title: '',
      snInfo: {}
    }
  },
  mounted () {
    this.getExamCertInfo();
  },
  methods: {
    getExamCertInfo () {
      var url = this.$root.apiBaseUrl + '?g=api&m=api2&a=exam_certinfo_api&sn=' + this.$route.query.sn;
      this.$http.get(url).then(function (response){
        if (response.body.status == 1) {
          this.snInfo = response.body.data;
        } else {
          this.$message.error(response.body.message);
        }
      }, function (reserror) {
        this.$message.error(reserror);
      })
    }
  }
}
</script>
<style lang="less" scoped>
.certificate{
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
  &-icon{
    margin: 43px auto 60px;
    width: 549px;
    height: 865px;
  }
}
</style>
